/**
 * Owner: Masa Bayu
 * File: ReaderLoadingGate.tsx
 * Date:Time: 2026-10-29 11:12
 * Description: Gerbang muatan /read — lipatan daun + bar, bukan kad teks sahaja.
 */

import type { ReactElement } from 'react';

export type ReaderLoadingGateProps = {
  readonly reason: string;
  readonly engine?: 'grabfold' | 'natural';
};

export function ReaderLoadingGate({
  reason,
  engine = 'grabfold',
}: ReaderLoadingGateProps): ReactElement {
  return (
    <section
      className="qx-nr qx-nr--gate"
      data-reader-state="loading"
      data-engine={engine}
      data-reader-loading={engine}
      aria-busy="true"
      aria-live="polite"
    >
      <div className="qx-nr-gate-card">
        <span className="qx-nr-gate-book" aria-hidden="true">
          <span className="qx-nr-gate-spine" />
          <span className="qx-nr-gate-leaf qx-nr-gate-leaf--left" />
          <span className="qx-nr-gate-leaf qx-nr-gate-leaf--right" />
        </span>
        <h1 className="qx-nr-gate-title">Memuatkan buku…</h1>
        <p className="qx-nr-gate-reason">{reason}</p>
        <span className="qx-nr-gate-track" aria-hidden="true">
          <span className="qx-nr-gate-fill" />
        </span>
      </div>
    </section>
  );
}
